import React from "react";

const DeleteIcon = ({fill = 'red', ...props}) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.83334 15.502C2.375 15.502 1.98264 15.3388 1.65625 15.0124C1.32986 14.686 1.16667 14.2937 1.16667 13.8353V3.00201H0.333336V1.33535H4.5V0.502014H9.5V1.33535H13.6667V3.00201H12.8333V13.8353C12.8333 14.2937 12.6701 14.686 12.3438 15.0124C12.0174 15.3388 11.625 15.502 11.1667 15.502H2.83334ZM11.1667 3.00201H2.83334V13.8353H11.1667V3.00201ZM4.5 12.1687H6.16667V4.66868H4.5V12.1687ZM7.83334 12.1687H9.5V4.66868H7.83334V12.1687Z"
        fill={fill}
      />
    </svg>
  );
};

export default DeleteIcon;
